import type { BadgeProps } from "@mantine/core";

import type { ChatTask } from "@/sdk";

import { ChatPreviewBadge } from "./ChatPreviewBadge";

export const PartnerBadge = ({ partner, ...rest }: Pick<ChatTask, "partner"> & BadgeProps) => (
    <ChatPreviewBadge tt="capitalize" {...rest} style={{ flexShrink: 0 }}>
        {partner}
    </ChatPreviewBadge>
);
